export const GET_WITHDRAW_ORDERS = 'GET_WITHDRAW_ORDERS';

export const OPT_WITHDRAW_ORDER = 'OPT_WITHDRAW_ORDER';

export const GET_STATISTICAL_WITHDRAWALS = 'GET_STATISTICAL_WITHDRAWALS';